import React from 'react';
import {BaseProps} from "../../../../infrastructure/models/props/base-props";
import {List, ListProps} from "../../../../core/components/misc/list/list";
import {
  CompetitorPlayersStatsModulePlayerStatsListItem
} from "./competitor-players-stats-module.player-stats.list-item";
import {
  CompetitorPlayersStatsModuleStatsListViewModel
} from "../../models/competitor-players-stats-module.stats-list.view-model";
import styles from "../../styles/competitor-players-stats-module.module.scss";
import classNames from "classnames";
import {CardTitleWrapper} from "../../../../core/components/misc/card-tite/card-title.wrapper";

export class CompetitorPlayersStatsModulePlayerStatsListProps extends BaseProps {
  playerStatsList: CompetitorPlayersStatsModuleStatsListViewModel;
}

export const CompetitorPlayersStatsModulePlayerStatsList = ({playerStatsList, controller}: CompetitorPlayersStatsModulePlayerStatsListProps) => {
  const listProps: ListProps = {
    items: playerStatsList.stats,
    ListItem: CompetitorPlayersStatsModulePlayerStatsListItem,
  }

  const cardTitleWrapperProps = {
    className: classNames(styles.player_stats_list_container),
    title: playerStatsList.title,
    controller
  }

  return (
    <CardTitleWrapper {...cardTitleWrapperProps}>
      <List {...listProps}/>
    </CardTitleWrapper>
  )
}
